import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AppNavbar from '../components/Navbar';

const AboutPage = () => {
  return (
    <>
      <AppNavbar />
      <Row className="limitedWidth">
        <Col>
          {process.env.REACT_APP_ABOUT_MESSAGE ? (
            <div
              dangerouslySetInnerHTML={{
                __html: process.env.REACT_APP_ABOUT_MESSAGE
              }}
            />
          ) : (
            <div>
              <h1>Document Collection browser</h1>
            </div>
          )}

          <h2>The Document Browser software</h2>
          <p>
            This document browsing system was initially developed as part of{' '}
            <a href="https://isaric4c.net/about/structure/">Work Package 8</a> (
            <i>Facilitating translation to local clinical guidelines</i>) of the{' '}
            <a href="https://isaric4c.net/">ISARIC4C</a> consortium, with the
            intention of creating a searchable collection of clinical
            guidelines.
          </p>

          <h3>Funding</h3>
          <p>
            ISARIC4C is funded by a grant from UKRI (MRC) to JK Baillie (PI),
            University of Edinburgh; MG Semple, University of Liverpool; and P
            Openshaw, Imperial College London (co-leads). See full list of{' '}
            <a href="https://isaric4c.net/about/structure">
              investigators and specific deliverables
            </a>
            .
          </p>

          <h3>Collaborators</h3>

          <p>
            The front-end was primarily developed by{' '}
            <a href="http://jamesscottbrown.com/">James Scott-Brown</a>{' '}
            (Visual+Interactive Data group, School of Informatics).
          </p>

          <p>
            The back-end was primarily developed by{' '}
            <a href="https://grv.overfit.xyz/">Andreas Grivas</a>, with
            contributions from Arlene Casey and{' '}
            <a href="http://homepages.inf.ed.ac.uk/grover/">Claire Grover</a>{' '}
            (all based in the Edinburgh Language Technology Group, Informatics).
            <a href="http://jamesscottbrown.com/">James Scott-Brown</a> also
            made some contributions.
          </p>

          <p>
            <a href="https://www.designinformatics.org/person/evan-morgan/">
              Evan Morgan
            </a>{' '}
            (Design Informatics) set up the CI pipeline and deployment to
            virtual machines.
          </p>

          <p>
            This work-package was supervised by{' '}
            <a href="http://benjbach.me/">Benjamin Bach</a> (Visual+Interactive
            Data group, School of Informatics) and{' '}
            <a href="https://www.ed.ac.uk/profile/dr-beatrice-alex">
              Beatrice Alex
            </a>{' '}
            (Edinburgh Language Technology Group, Edinburgh Futures Institute,
            School of Literatures, Languages and Cultures and Informatics).
          </p>

          <p>
            <a href="https://www.ed.ac.uk/clinical-sciences/divisionpgdi/anaesthesia/team-members/researchers/dr-kenny-baillie">
              Kenneth Baillie
            </a>{' '}
            (RIE and The Roslin Institute) and{' '}
            <a href="https://www.ed.ac.uk/infection-medicine/our-staff/associate-members/clark">
              Clark Russell
            </a>{' '}
            (Centre for Inflammation Research and The Roslin Institute) provided
            input into the design from the perspective of clinician end-users.
            Kenneth Baillie also conceived of the project and obtained funding.
          </p>

          <p>
            The banner image was designed by{' '}
            <a href="https://matteofarinella.com">Matteo Farinella</a>.{' '}
          </p>

          <a href="https://www.isaric4c.net">
            <img
              src="/images/ISARIC4C-logo.svg"
              alt="ISARIC4C logo"
              width="200px"
            />
          </a>
        </Col>
      </Row>
    </>
  );
};

export default AboutPage;
